(() => {
  const initializeWithdrawalForm = (scope = document) => {
    const root = scope.matches?.('[data-nh-withdrawal]')
      ? scope
      : scope.querySelector?.('[data-nh-withdrawal]');
    if (!root || root.dataset.nhWithdrawalReady === 'true') return;

    const form = root.querySelector('#Widerrufsformular');
    const iframe = root.querySelector('#widerrufHiddenFrame');
    const success = root.querySelector('#WiderrufSuccess');
    const error = root.querySelector('#WiderrufError');
    const submit = root.querySelector('#WiderrufSubmit');
    const submitLabel = submit?.querySelector('span:first-child');
    const submittedAt = root.querySelector('#WiderrufSubmittedAt');
    const timezone = root.querySelector('#WiderrufTimezone');
    const partialWithdrawal = root.querySelector('#WiderrufTeil');
    const scopeOptions = form?.querySelectorAll('input[name="scope"]') || [];
    const articles = root.querySelector('#WiderrufArtikel');
    if (!form || !iframe || !success || !submit || !submitLabel) return;

    root.dataset.nhWithdrawalReady = 'true';
    let formWasSubmitted = false;
    let timeoutId;

    const updateArticleRequirement = () => {
      if (!partialWithdrawal || !articles) return;
      articles.required = partialWithdrawal.checked;
      articles.setAttribute('aria-required', partialWithdrawal.checked ? 'true' : 'false');
    };

    scopeOptions.forEach((option) => option.addEventListener('change', updateArticleRequirement));
    updateArticleRequirement();

    form.addEventListener('submit', () => {
      formWasSubmitted = true;
      if (submittedAt) submittedAt.value = new Date().toISOString();
      if (timezone) timezone.value = Intl.DateTimeFormat().resolvedOptions().timeZone || 'Unbekannt';

      success.hidden = true;
      if (error) error.hidden = true;
      submit.disabled = true;
      submitLabel.textContent = 'Widerruf wird übermittelt ...';

      timeoutId = window.setTimeout(() => {
        if (!formWasSubmitted) return;
        submit.disabled = false;
        submitLabel.textContent = 'Widerruf bestätigen';
        if (error) {
          error.hidden = false;
          error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 15000);
    });

    iframe.addEventListener('load', () => {
      if (!formWasSubmitted) return;
      formWasSubmitted = false;
      if (timeoutId) window.clearTimeout(timeoutId);

      success.hidden = false;
      if (error) error.hidden = true;
      submit.disabled = false;
      submitLabel.textContent = 'Widerruf bestätigen';
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithdrawalForm());
  } else {
    initializeWithdrawalForm();
  }

  document.addEventListener('shopify:section:load', (event) => initializeWithdrawalForm(event.target));
})();
